<template>
  <v-dialog max-width="454px" :value="open" @click:outside="$emit('close')">
    <v-card class="pa-6 d-flex flex-column justify-center align-center">
      <p class="font-size-20 font-bold py-4 mb-0 h6 headline w-100">
        {{ $t('common.great_title') }}
      </p>
      <p
        class="message text-start body-1 font-size-16 blue-grey--text text--darken-1"
      >
        {{ $t('routines.improvement_idea_dialog') }}
      </p>

      <v-card-actions class="d-flex justify-end pa-0 w-100">
        <Button
          color="primary"
          :text="$t('common.button.start')"
          @click="$emit('start')"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Button from '@/components/UI/Button'

export default {
  props: {
    open: Boolean,
    title: String,
  },
  components: {
    Button,
  },
}
</script>

<style lang="scss" scoped>
.message {
  white-space: pre-line;
}
</style>
